<template>
  <WdsStack direction-row justify-space-between align-center class="tw-py-0.5">
    <WdsText v-if="data.title" :text="data.title" secondary sm />
    <WdsAvatarLabel :path="avatar" :text="data.user.name" sm />
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsStack, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'

const ComplianceDataUserFragment = graphql(`
  fragment ComplianceDataUser on ComplianceDataUser {
    title
    user {
      id
      name
      avatar
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataUserFragment> }>()
const data = computed(() => useFragment(ComplianceDataUserFragment, props.entry))
const avatar = computed(() => getAvatarPath(data.value.user.avatar, data.value.user.id))
</script>
